import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StatusCandidato } from '../../../models/statusCandidato';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { CandidatoService } from '../../candidato/candidato.service';
import { Util } from '../../shared/util';
import { ConfirmationService } from 'primeng/primeng';
import { AuthService } from '../../admin/auth.service';

@Component({
  templateUrl: './gerenciar-prova-pratica.component.html'
})
export class GerenciarProvaPraticaComponent extends WebPage implements OnInit {

  idCandidato;
  candidato;
  listaHistoricoProvaPratica: any[];

  constructor(
    private route: ActivatedRoute, private router: Router,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private authService: AuthService,
    private candidatoService: CandidatoService, private arquivoService: ArquivoService,

  ) {
    super(messageService);

    this.route.paramMap.subscribe(params =>
      this.idCandidato = params.get('idCandidato')
    );
  }

  ngOnInit() {
    this.isLoading = true;
    this.candidatoService.getFull(this.idCandidato)
      .finally(() => this.isLoading = false)
      .subscribe(
        candidato => {
          this.candidato = candidato;
          this.listaHistoricoProvaPratica =
            candidato.candidatoHistorico
              .filter(this.getHistoricoProvaPratica)
              .sort(this.ordenaHistoricosPorData);
        },
        error => this.gerenciaErro(error)
      );
  }

  gerarGuia() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja emitir a guia de encaminhamento para este aluno?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        const usuario = this.authService.informacoesUsuario();
        this.candidatoService.encaminharProvaPratica(this.idCandidato, usuario.Nome);

        window.setTimeout(() => this.router.navigate(['/gerenciar-etapas']), 2000);
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  getHistoricoProvaPratica(historico) {
    return historico.idStatusCandidato.toLowerCase() === StatusCandidato.EncaminhadoRealizacaoProvaPratica.toLowerCase()
      || historico.idStatusCandidato.toLowerCase() === StatusCandidato.AprovadoProvaPratica.toLowerCase()
      || historico.idStatusCandidato.toLowerCase() === StatusCandidato.ReprovadoProvaPratica.toLowerCase();
  }

  ordenaHistoricosPorData(historico1, historico2) {
    return historico1.dataRegistro > historico2.dataRegistro ? -1 : historico1.dataRegistro < historico2.dataRegistro ? 1 : 0;
  }

  getNomeEvento(idStatusCandidato) {
    return (idStatusCandidato.toLowerCase() === StatusCandidato.EncaminhadoRealizacaoProvaPratica.toLowerCase())
      ? 'Solicitação de Prova Prática'
      : 'Resultado do Prova Prática';
  }

  getResultado(idStatusCandidato) {
    if (idStatusCandidato.toLowerCase() === StatusCandidato.EncaminhadoRealizacaoProvaPratica.toLowerCase()) {
      return '-';
    }

    return (idStatusCandidato.toLowerCase() === StatusCandidato.AprovadoProvaPratica.toLowerCase())
      ? 'Aprovado'
      : 'Reprovado';
  }

  downloadResultado(idArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, 'Resultado_prova');
  }

  podeMostrarBotaoCadastroResultados() {
    if (Util.isNullOrEmptyOrUndefined(this.candidato)) {
      return false;
    }

    const idStatusCandidato = this.candidato.idStatusCandidato.toUpperCase();
    return idStatusCandidato === StatusCandidato.EncaminhadoRealizacaoProvaPratica
      || idStatusCandidato === StatusCandidato.ReprovadoProvaPratica;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/provaPratica/gerenciar-prova-pratica/gerenciar-prova-pratica.component.ts